import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import React from "react";
import { Row, Col, Button } from "react-bootstrap";

interface BreadcrumbItemProps {
  mainTitle: string;
  subTitle: string;
  buttonTitle?: string;
  buttonIcon?: string;
  onCtaClick?: () => void;
}


const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  mainTitle,
  subTitle,
  buttonTitle,
  buttonIcon,
  onCtaClick,
}) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>{subTitle} | SafeSignal</title>
      </Helmet>
      <div className="page-header">
        <div className="page-block">
          <Row className="align-items-center mb-4">
            <Col>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-1">
                  <li className="breadcrumb-item">
                    <Link to="#" className="text-muted text-decoration-none">
                      {mainTitle}
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item active fw-semibold"
                    aria-current="page"
                  >
                    {subTitle}
                  </li>
                </ol>
              </nav>

              <h2 className="mb-0 fw-bold">{subTitle}</h2>
            </Col>

            {buttonTitle && (
              <Col xs="auto">
                <Button
                  variant="primary"
                  className="d-flex align-items-center gap-2 px-3"
                  onClick={onCtaClick}
                >
                  <i className={`${buttonIcon || "ri-add-line"} align-middle`} />
                  {buttonTitle}
                </Button>
              </Col>
            )}
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};


export default BreadcrumbItem;
